import * as actionType from './action-type'
import initialState from './initial-state'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionType.SET_SLIDE_SUB_MENU:
      return {
        ...state,
        ...payload
      }
    case actionType.SET_CURRENT_CATEGORY:
      return {
        ...state,
        currentCategory: payload.currentCategory
      }
    default:
      return state
  }
}
